/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Grid } from "@mui/material";
import { Box } from "@mui/material";
import { DateTimeInput } from "components/Common/DateTimeInput";
import { DateTimeRange } from "components/TaskRegisterMultipleCharge/hooks/GetMultipleChargeTasksHook";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { validateFromTo } from "utils/DateTime";

interface RequestedEndDatetimesInputProps {
  requestedEndDatetimes?: DateTimeRange;
  onChange?: (from: Date, to: Date) => void;
}

export const RequestedEndDatetimesInput: FC<
  RequestedEndDatetimesInputProps
> = ({ requestedEndDatetimes, onChange }) => {
  const { t } = useTranslation();
  const [from, setFrom] = useState(requestedEndDatetimes?.from ?? new Date());
  const [to, setTo] = useState(requestedEndDatetimes?.to ?? new Date());
  const [valid, setValid] = useState(
    validateFromTo(
      requestedEndDatetimes?.from ?? new Date(),
      requestedEndDatetimes?.to ?? new Date()
    )
  );
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs={11.5}>
        <Box mb={1}>
          <DateTimeInput
            label={t("AWVUI-MSG210")}
            date={from}
            onDateTimeSelected={(date) => {
              if (date != null) {
                setValid(validateFromTo(date, to));
                setFrom(date);
                onChange?.(date, to);
              }
            }}
            valid={valid[0]}
          />
        </Box>
      </Grid>
      <Grid item xs={11.5}>
        <Box mb={1}>
          <DateTimeInput
            label={t("AWVUI-MSG211")}
            date={to}
            onDateTimeSelected={(date) => {
              if (date != null) {
                setValid(validateFromTo(from, date));
                setTo(date);
                onChange?.(from, date);
              }
            }}
            valid={valid[1]}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
